import WelcomePageComponent from "./WelcomePageComponent";
export default WelcomePageComponent;
